import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchcategoriesById, fetchPcategories} from "../../../../../../reduxLib/pcategoriesLib";

export default function ViewProductModal({ open, setOpen, product }) {

    const dispatch = useDispatch();
    //categories fetch
    const [categoryOptions, setCategoryOptions] = useState(null);
    const catstate=useSelector((state)=> state.categoryreducer.state);
    const categories= useSelector((state)=> state.categoryreducer.selectedCategory);

    useEffect(()=>{

        if(!categories || categories.length === 0) {
            // Fetch the event by ID when the component mounts or when the id changes
            dispatch(fetchcategoriesById(product?.categoryRelId)).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setCategoryOptions(action.payload);
                    console.log("playload ", action.payload);
                    console.log("playload E", categoryOptions);
                }
            });
        }
        else {
            //let f=events.filter((event) => event.ownerid === id);
            // If the event data is already available, set the eventprofile state

            setCategoryOptions(categories);
            console.log("not disp ",categories);
        }
    }, [dispatch,catstate]);



    const files = useMemo(() => product?.filesRelated ?? [], [product]);
    const initialMain = files?.[0]?.fileLocation || product?.filesRelated?.[0]?.fileLocation || "";
    const [mainImage, setMainImage] = useState(initialMain);

    console.log(product);
    // όταν αλλάζει product, ανανέωσε mainImage
    React.useEffect(() => {
        const first = product?.filesRelated?.[0]?.fileLocation || "";
        setMainImage(first);
    }, [product]);

    if (!open) return null;

    const price = product?.price != null ? Number(product.price).toFixed(2) : "";


    function SpecItem({ label, value }) {
        if (!value) return null;

        return (
            <div>
                <p className="text-xs text-gray-500">{label}</p>
                <p className="text-sm font-medium text-gray-900">
                    {value}
                </p>
            </div>
        );
    }

    return (
        <div
            id="view-product-modal"
            className="modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => setOpen(false)}
        >
            <div
                className="bg-white rounded-lg p-8 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-serif font-bold text-custom-green">
                        Product Details
                    </h2>
                    <button
                        onClick={() => setOpen(false)}
                        className="text-gray-400 hover:text-gray-600"
                        aria-label="Close"
                    >
                        <i className="fa-solid fa-times text-xl"></i>
                    </button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {/* LEFT: images */}
                    <div>
                        <div className="bg-gray-100 rounded-lg p-6 text-center mb-4">
                            {mainImage ? (
                                <img
                                    src={mainImage}
                                    alt={product?.name || "Product"}
                                    className="w-full h-64 object-cover rounded-lg"
                                />
                            ) : (
                                <div className="w-full h-64 flex items-center justify-center text-gray-500">
                                    No image
                                </div>
                            )}
                        </div>

                        {files?.length > 0 && (
                            <div className="grid grid-cols-4 gap-2">
                                {files.slice(0, 8).map((f, idx) => {
                                    const src = f?.fileLocation;
                                    const isActive = src && src === mainImage;
                                    return (
                                        <button
                                            key={f?.id ?? `${src}-${idx}`}
                                            type="button"
                                            onClick={() => src && setMainImage(src)}
                                            className={`rounded border ${isActive ? "border-2 border-custom-green" : "border"}`}
                                            title="Select image"
                                        >
                                            <img
                                                src={src}
                                                alt={`thumb-${idx}`}
                                                className="w-full h-16 object-cover rounded"
                                            />
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {/* RIGHT: details */}
                    <div className="space-y-6">

                        {/* Title / Description */}
                        <div>
                            <h3
                                className="text-xl font-serif font-bold text-gray-900 mb-2"
                                id="view-product-name"
                            >
                                {product?.name}
                            </h3>

                            <p className="text-gray-600 mb-4">
                                {product?.description}
                            </p>

                            <div className="flex items-center space-x-4 mb-4">
            <span className="text-2xl font-bold text-custom-green">
                {price ? `€${price}` : "—"}
            </span>

                                {product?.canBeOrdered ? (
                                    <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    Available
                </span>
                                ) : (
                                    <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
                    Not Available
                </span>
                                )}
                            </div>
                        </div>

                        {/* Quick Product Info */}
                        <div className="grid grid-cols-2 gap-4">

                            <div>
                                <label className="text-sm font-medium text-gray-700">
                                    Product ID
                                </label>

                                <p className="text-gray-900">
                                    {product?.productID ?? "—"}
                                </p>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700">
                                    Category
                                </label>

                                <p className="text-gray-900">
                                    {product?.categoryRelId}
                                    {categoryOptions?.name
                                        ? ` (${categoryOptions.name})`
                                        : ""}
                                </p>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700">
                                    Size
                                </label>

                                <p className="text-gray-900">
                                    {product?.size ?? "—"}
                                </p>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700">
                                    Dimensions
                                </label>

                                <p className="text-gray-900">
                                    {product?.dimentions ??
                                        product?.dimensions ??
                                        "—"}
                                </p>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700">
                                    Construction Days
                                </label>

                                <p className="text-gray-900">
                                    {product?.constructionEffortDays ??
                                        "—"}
                                </p>
                            </div>
                        </div>

                        {/* Product Options */}
                        <div className="border-t pt-6">
                            <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                                Product Options
                            </h4>

                            <div className="space-y-4">

                                {/* Textile Options */}
                                {Array.isArray(product?.availableTextiles) &&
                                    product.availableTextiles.length > 0 && (
                                        <div>
                                            <label className="text-sm font-medium text-gray-700 block mb-2">
                                                Textile Options
                                            </label>

                                            <div className="flex flex-wrap gap-2">
                                                {product.availableTextiles.map((t) => (
                                                    <span
                                                        key={t}
                                                        className="px-3 py-1 text-sm rounded-full bg-gray-100 text-gray-700 border"
                                                    >
                                    {t}
                                </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                {/* Plexis Options */}
                                {Array.isArray(product?.availablePlexis) &&
                                    product.availablePlexis.length > 0 && (
                                        <div>
                                            <label className="text-sm font-medium text-gray-700 block mb-2">
                                                Plexis Options
                                            </label>

                                            <div className="flex flex-wrap gap-2">
                                                {product.availablePlexis.map((p) => (
                                                    <span
                                                        key={p}
                                                        className="px-3 py-1 text-sm rounded-full bg-gray-100 text-gray-700 border"
                                                    >
                                    {p}
                                </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                {/* Closing Options */}
                                {Array.isArray(product?.availableClosingTextiles) &&
                                    product.availableClosingTextiles.length > 0 && (
                                        <div>
                                            <label className="text-sm font-medium text-gray-700 block mb-2">
                                                Closing Options
                                            </label>

                                            <div className="flex flex-wrap gap-2">
                                                {product.availableClosingTextiles.map((c) => (
                                                    <span
                                                        key={c}
                                                        className="px-3 py-1 text-sm rounded-full bg-gray-100 text-gray-700 border"
                                                    >
                                    {c}
                                </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                {/* Available Colors */}
                                {Array.isArray(product?.allowedColors) &&
                                    product.allowedColors.length > 0 && (
                                        <div>
                                            <label className="text-sm font-medium text-gray-700 block mb-2">
                                                Available Colors
                                            </label>

                                            <div className="flex flex-wrap gap-2">
                                                {product.allowedColors.map((c, idx) => {

                                                    const key =
                                                        c?.pcid ??
                                                        `${c?.colorName ?? "color"}-${idx}`;

                                                    const label =
                                                        c?.colorName ??
                                                        c?.ColorName ??
                                                        "—";

                                                    const hex =
                                                        c?.hexColor ??
                                                        c?.HexColor;

                                                    return (
                                                        <span
                                                            key={key}
                                                            className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-700 inline-flex items-center gap-2 border"
                                                            title={hex || ""}
                                                        >
                                        {hex ? (
                                            <span
                                                className="inline-block w-3 h-3 rounded-full border"
                                                style={{
                                                    backgroundColor: hex
                                                }}
                                            />
                                        ) : null}

                                                            {label}
                                    </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </div>

                        {/* Details */}
                        {product?.details && (
                            <div className="border-t pt-6">
                                <label className="text-sm font-medium text-gray-700">
                                    Details
                                </label>

                                <p className="text-gray-900 mt-2 whitespace-pre-line">
                                    {product.details}
                                </p>
                            </div>
                        )}

                        <div className="flex justify-end gap-3 pt-4">
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                className="px-6 py-2 bg-custom-green text-white rounded-lg hover:bg-opacity-90"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
